import { getAuth } from "firebase/auth";
import { useSignInWithGoogle } from "react-firebase-hooks/auth";
import { useNavigate,useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import React, { useEffect, useState } from "react";
import { app } from "./firebase.js";

const auth = getAuth();

export function SignIn() {
  const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(auth);
  const imageUrl = "https://firebasestorage.googleapis.com/v0/b/monterrave-1f76f.firebasestorage.app/o/ImagenesGlobal%2FLogoTransparente2.png?alt=media";
  const [flyerUrls, setFlyerUrls] = useState([]);
  const role_change = useLocation();
  const pathSections = role_change.pathname.split("/").filter(Boolean);
  const role=pathSections[1];
  const uid = pathSections.length > 0 ? pathSections[0] : "0";

  useEffect(() => {
    const fetchFlyers = async () => {
      try {
        const storage = getStorage(app);
        const flyersRef = ref(storage, "/Flyers/");
        // Import listAll from firebase/storage
        const { listAll, getDownloadURL } = await import("firebase/storage");
        const res = await listAll(flyersRef);
        const urls = await Promise.all(
          res.items.map((itemRef) => getDownloadURL(itemRef))
        );
        setFlyerUrls(urls);
      } catch (err) {
        console.error("Error fetching flyers:", err);
      }
    };
    fetchFlyers();
  }, []);

  const renderRoleContent = () => {
    if (uid.length === 28) {
      return (
        <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h4 className="text-white font-normal" style={{ margin: 0 }}>
            Se necesita iniciar sesión para continuar con la compra
          </h4>
          <br />
          <br />
      </div>
      <br></br>
        <button className="signin-button" onClick={() => signInWithGoogle()}>
          Iniciar Sesión <FontAwesomeIcon icon={faGoogle} />
        </button>
        <br />
        <img
          src={imageUrl}
          alt="Logo"
          style={{ width: "50px", height: "50px" }}
        />
        </>
      );
    } else if (role === "rp") {
      return <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h4 className="text-white font-normal" style={{ margin: 0 }}>
            Se necesita iniciar sesión antes de ser registrado como RP
          </h4>
          <br />
          <br />
      </div>
      <br></br>
        <button className="signin-button" onClick={() => signInWithGoogle()}>
          Iniciar Sesión <FontAwesomeIcon icon={faGoogle} />
        </button>
        <br />
        <img
          src={imageUrl}
          alt="Logo"
          style={{ width: "50px", height: "50px" }}
        />
      </>;
    } else if (role === "scanner") {
      return <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <h4 className="text-white font-normal" style={{ margin: 0 }}>
            Se necesita iniciar sesión antes de ser registrado como Scanner
          </h4>
          <br />
          <br />
      </div>
      <br></br>
        <button className="signin-button" onClick={() => signInWithGoogle()}>
          Iniciar Sesión <FontAwesomeIcon icon={faGoogle} />
        </button>
        <br />
        <img
          src={imageUrl}
          alt="Logo"
          style={{ width: "50px", height: "50px" }}
        />
      </>;
    } else {
      return <>
      <div style={{ display: "flex", alignItems: "center" }}>
          <h4 className="text-white" style={{ margin: 0 }}>
            FIESTAS
          </h4>
          <div
            style={{
              width: "2px",
              height: "1.5em",
              background: "#fff",
              margin: "0 12px",
            }}
          />
          <h4 className="text-white" style={{ margin: 0 }}>
            RAVES
          </h4>
          <div
            style={{
              width: "2px",
              height: "1.5em",
              background: "#fff",
              margin: "0 12px",
            }}
          />
          <h4 className="text-white" style={{ margin: 0 }}>
            MORE...
          </h4>
          <br />
          <br />
      </div>
        <p>GOOD VIBES ONLY</p>
        <button className="signin-button" onClick={() => signInWithGoogle()}>
          Iniciar sesión/Crear Cuenta <FontAwesomeIcon icon={faGoogle} />
        </button>
        <img
          src={imageUrl}
          alt="Logo"
          style={{ width: "110px", height: "110px" }}
        /></>;
    }
  };


  if (error) {
    return (
      <div>
        <p>Error: {error.message}</p>
      </div>
    );
  }
  if (loading) {
    return <p>Loading...</p>;
  }
  if (user) {
    return (
      <div>
        <p>Signed In User: {user.email}</p>
      </div>
    );
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="mntrv-container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1 className="text-white">INICIA SESIÓN PARA ACCEDER</h1>
        <br />
        <p>COMUNIDAD UNDERGROUND EN MONTERREY </p>
        <br />
        
        
        {renderRoleContent()}

        
      </div>
      
    </div>
  );
}

export function LogOut() {
  const navigate = useNavigate();
  const handleSignOut = () => {
    auth.signOut();
    navigate("/");
    window.location.reload();
  };
  return (
    <div className="logout">
      <a onClick={handleSignOut}>Log out</a>
    </div>
  );
}
